import React, { type PropsWithChildren } from 'react';
import styled from 'styled-components';

const Container = styled.div`
  background: #fff;
  border-radius: 3px;
  border: 1px solid #e4e4e4;
  display: flex;
  flex-direction: column;
  height: fit-content;
`;

const HeaderContainer = styled.div`
  border-bottom: 1px solid #e4e4e4;
  display: flex;
  justify-content: space-between;
  margin-bottom: 0;
  min-height: 53px;
  padding: 10px;
`;

// Should look the same as client/src/components/UI/Table/TableHeader.tsx#TitleLabel
// However I'm not bothering with the size variants as this is only used
// in one context: TagsManager inside EditDocumentModal
const TitleLabel = styled.h1`
  font-size: 14px;
  font-weight: 600;
  margin: 0;
  align-self: center;
`;

export type CardWrapperProps = PropsWithChildren<{
  title: string;
}>;

function CardWrapper({ children, title }: CardWrapperProps) {
  return (
    <Container>
      <HeaderContainer>
        <TitleLabel>{title}</TitleLabel>
      </HeaderContainer>
      {children}
    </Container>
  );
}

export default CardWrapper;
